import { WordPressSources } from "../consts";
// Publications page
export async function fetchPublications() {
    const response = await fetch(WordPressSources.publications);
    const json = await response.json();
    const parsedData = [];
    json.forEach(item => {
        parsedData.push(parseRawPublicationsJSON(item));
    });
    return parsedData;
}
function parseRawPublicationsJSON(json) {
    const parsed = {
        category: json.title.rendered
    };
    // Parse ul html string into 'list' array
    const regex = /<li>(.*?)<\/li>/gi;
    const tagIncludedArray = json.content.rendered.match(regex);
    // Convert <li> and </li> array into entries into list array
    if (tagIncludedArray !== null) {
        parsed.list = [];
        tagIncludedArray.forEach(element => {
            let stripped = element.replace("<li>", "");
            stripped = stripped.replace("</li>", "");
            parsed.list.push(stripped);
        });
    }
    // Parse table string into 'objectList' array
    const trRegex = /<tr><td>(.*?)<\/td><\/tr>/g;
    const tagIncludedTrArray = json.content.rendered.match(trRegex);
    // If html text has a table then turn table into object array
    if (tagIncludedTrArray !== null) {
        parsed.objectList = [];
        tagIncludedTrArray.forEach(element => {
            const parsedObject = {};
            const tdRegex = /<td>(.*?)<\/td>/g;
            const tagIncludedTdArray = element.match(tdRegex);
            tagIncludedTdArray.forEach((e, index) => {
                let stripped = e.replace("<td>", "");
                stripped = stripped.replace("</td>", "");
                switch (index) {
                    case 0:
                        parsedObject.year = stripped;
                        break;
                    case 1:
                        parsedObject.link = stripped;
                        break;
                    case 2:
                        parsedObject.text = stripped;
                        break;
                }
            });
            parsed.objectList.push(parsedObject);
        });
    }
    return parsed;
}
